import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    expandedNodeData: []
}

const expansionTreeSlice = createSlice({
    name: 'expanTree',
    initialState,
    reducers: {
        setExpansionData: (state, action) => {
            state.expandedNodeData = action.payload
        }
    }
})

export const { setExpansionData } = expansionTreeSlice.actions

export default expansionTreeSlice.reducer